import { registerFeature } from "lib/features"
import { FEATURE_FLAG_REGIME_AUDITING } from "./server/feature-flag-regime-auditing.mjs"

registerFeature({
    numericalId: 17,
    name: "Regime Auditing",
    id: FEATURE_FLAG_REGIME_AUDITING,
    description: `Enables auditing when a regime is submitting for review or the review is rejected.`,
    readyForProduction: true,
})
